
import { defineComponent, computed } from 'vue'

export default defineComponent({
    props: {
        costPriceWidthNds: {
            type: Number,
            default: null
        },
        ftlType: {
            type: Number,
            default: null
        },
        paymentRateTypeId: {
            type: Number,
            default: null
        },
        costPricePerHour: {
            type: Number,
            default: null,
        },
        costPrice: {
            type: Number,
            default: null,
        },
        paymentMethodName: {
            type: String,
            default: null
        },
        paidPrice: {
            type: Number,
            default: null
        },
        isPrepayment: {
            type: Number,
            default: null,
        },
        customPayment: {
            type: Object,
            default: null
        }
    },
    setup(props) {
        const formatAmount = (amount: string | number | null) => {
            if (amount) {
                return `${amount.toLocaleString('ru-RU')} ₸`
            }

            return '0 ₸'
        }

        const costTitle = computed(() => {
            let title = 'Себестоимость'

            if (props.costPriceWidthNds === 1) {
                title += ' (с НДС)'
            } else {
                title += ' (без НДС)'
            }

            if (props.ftlType === 2) {
                if (props.paymentRateTypeId === 2) {
                    title += ' за рейс'
                } else {
                    title += ' за час'
                }
            }

            return title
        })

        const costPriceValue = computed(() => {
            let cost_price = 0

            if (props.paymentRateTypeId === 1) {
                cost_price = props.costPricePerHour
            } else {
                cost_price = props.costPrice
            }

            return formatAmount(cost_price)
        })

        const paidPriceTitle = computed(() => {
            let title = 'Выставление'

            if (props.ftlType === 2) {
                if (props.paymentRateTypeId === 1) {
                    title += ' за час'
                } else {
                    title += ' за рейс'
                }
            }

            return title
        })

        const invoiceCost = computed(() => {
            if (props.customPayment) {
                return props.customPayment.invoice_cost
            }

            return '-'
        })

        const invoiceName = computed(() => {
            if (props.customPayment) {
                if (props.customPayment.invoice_currency_type) {
                    return props.customPayment.invoice_currency_type.name
                }
            }

            return '-'
        })

        return {
            formatAmount,
            costTitle,
            costPriceValue,
            paidPriceTitle,
            invoiceCost,
            invoiceName
        }
    }
})
